  document.addEventListener('DOMContentLoaded', () => {
    const journal = document.querySelector('[data-journal]');
    if (!journal) return;

    const tabs = journal.querySelectorAll('[data-filter]');
    const filterTargets = journal.querySelectorAll('[data-tags]');
    const emptyState = journal.querySelector('[data-journal-empty]');

    const applyFilter = (filter) => {
      let visibleCount = 0;

      filterTargets.forEach((item) => {
        const tags = (item.getAttribute('data-tags') || '').split(',').map((value) => value.trim());
        const show = filter === 'all' || tags.includes(filter);
        item.setAttribute('data-hidden', show ? 'false' : 'true');
        if (show) visibleCount += 1;
      });

      if (emptyState) {
        emptyState.hidden = visibleCount > 0;
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((tabItem) => {
        tabItem.classList.remove('is-active', 'active');
          tabItem.setAttribute('aria-selected', 'false');
        });

      tab.classList.add('is-active', 'active');
        tab.setAttribute('aria-selected', 'true');
        applyFilter(tab.dataset.filter);
      });
    });

    applyFilter('all');
  });
